import { baseApi } from 'shared/api';

export const appApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    downloadRepairInstruction: build.query<Blob, string>({
      query: (url) => ({
        url: window.location.origin.concat(url),
        method: 'GET',
        responseHandler: (response) => response.blob(),
      }),
    }),
  }),
});
